import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Badge } from '../components/ui/badge';
import { Card, CardContent } from '../components/ui/card';
import { Briefcase, Users } from 'lucide-react';

const CareersPage = () => {
  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-6 bg-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-16">
            <Badge className="bg-[#E8E3DA] text-[#4A5D4E] border-none mb-4">
              <Briefcase className="w-3 h-3 mr-1" />
              Careers at Punarvibes
            </Badge>
            <h1 className="text-5xl font-bold text-[#2C3E2F] mb-6">
              Join Our Team
            </h1>
            <p className="text-xl text-[#5A6B5E] max-w-3xl mx-auto leading-relaxed">
              Be part of building the next generation of circular materials
            </p>
          </div>

          {/* No Open Positions Card */}
          <div className="max-w-3xl mx-auto">
            <Card className="border-[#DDD5C7] text-center">
              <CardContent className="p-12">
                <div className="w-20 h-20 bg-[#A8C9A5]/20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Users className="w-10 h-10 text-[#4A5D4E]" />
                </div>
                <h2 className="text-2xl font-bold text-[#2C3E2F] mb-4">
                  No Open Positions at the Moment
                </h2>
                <p className="text-lg text-[#5A6B5E] mb-6">
                  We do not have any open positions at the moment. Please check back soon for future opportunities.
                </p>
                <div className="bg-[#F5F3EE] rounded-lg p-6 mt-8">
                  <h3 className="font-semibold text-[#2C3E2F] mb-3">Stay Connected</h3>
                  <p className="text-[#5A6B5E]">
                    Interested in working with us? Keep an eye on this page for updates on future openings 
                    in research, operations, and business development.
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Why Work With Us Section */}
      <section className="py-20 px-6 bg-[#FDFBF7]">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-[#2C3E2F] mb-4">
              Why Work at Punarvibes?
            </h2>
            <p className="text-lg text-[#5A6B5E] max-w-3xl mx-auto">
              Join a mission-driven team building circular material solutions for a sustainable future
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                title: 'Impact-Driven Work',
                description: 'Contribute to real environmental solutions through cutting-edge biomaterial research'
              },
              {
                title: 'Innovation & Learning',
                description: 'Work at the intersection of biology, materials science, design and circular economy'
              },
              {
                title: 'Growth Opportunity',
                description: 'Be part of an early-stage startup with significant growth potential'
              }
            ].map((item) => (
              <Card key={item.title} className="border-[#DDD5C7] hover:shadow-lg transition-shadow">
                <CardContent className="p-6 text-center">
                  <h3 className="text-xl font-bold text-[#2C3E2F] mb-3">{item.title}</h3>
                  <p className="text-[#5A6B5E]">{item.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CareersPage;
